export enum ReportMenuItem {
    Customers,
    DataQualityRejection,
    Regularization,
    DuplicateEnumeration
}